import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Divider,
  Stack,
  IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PageIcons } from "src/assets/icons";
import PageTypography from "../../components/PageTypography/PageTypography";
import { getRole } from "src/utils/session";

interface DualLanguageItem {
  id: number | string;
  title: string;
  Sub_title:string;
  content: string;
  Sub_content: string;
}

interface Props {
  items: DualLanguageItem[];
  onEdit?: (item: DualLanguageItem) => void;
  onDelete?: (item: DualLanguageItem) => void;
  onView?: (item: DualLanguageItem) => void;
}

const Accordions: React.FC<Props> = ({ items, onEdit, onDelete,onView }  ) => {
      const role = getRole();

      const isAdmin = role?.[0] === "Admin";
    const isAdminStaff = role?.[0] === "AdminStaff";
  return (
    <Box sx={{ width: "100%" }}>
      {items.map((item) => (
        <>
        <Accordion key={item.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>

            <PageTypography sx={{ fontWeight: "bold" }}>
              {item.title}  {item.Sub_title}
            </PageTypography>
            {
              (isAdmin || isAdminStaff) && (
           
                          <Stack direction="row" spacing={1}>
                                  {onView && (
                  <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); onView(item); }}>
                    <PageIcons.View />
                  </IconButton>
                )}
                {onEdit && (
                  <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); onEdit(item); }}>
                    <PageIcons.Edit />
                  </IconButton>
                )}
                {onDelete && (
                  <IconButton size="small" color="error" onClick={(e) => { e.stopPropagation(); onDelete(item); }}>
                    <PageIcons.Delete />
                  </IconButton>
                )}
              </Stack>
              )}
</Box>
          </AccordionSummary>

          <AccordionDetails>

            {/* English Content */}
            <PageTypography sx={{ mb: 2 }}>{item.content}</PageTypography>

            {/* Arabic Content */}
            <PageTypography >
              {item.Sub_content}
            </PageTypography>

          </AccordionDetails>
        </Accordion>
        <Divider/>
        </>
      ))}
    </Box>
  );
};

export default Accordions;
